module.exports = __webpack_public_path__ + "img/3.08bd0c70.jpg";